import { createSelector } from 'reselect'
import createPaymentScheduleSelector from './createPaymentScheduleSelector'
import { PAYMENT_SCHEDULE_TYPE, STATIC_PAYMENT_SCHEDULE_TEMPLATE_ID } from 'constants/payment'
import type { StaticPaymentScheduleOption } from 'constants/payment'
import { getReserveForZeroPaymentScheduleRequestInfo } from './reserveForZeroPaymentSchedule'
import { getCustomOfferV2ScheduleRequestInfo } from './customOfferV2Schedule'
import {
  isLpc50DepositExperimentControlSuppressesSchedules,
  isLpc50DepositExperimentVariantForces50Schedule,
} from './lpc50PercentDepositPaymentSchedule'

const offerStaticPaymentScheduleRequestInfo = createPaymentScheduleSelector(PAYMENT_SCHEDULE_TYPE.STATIC)

const getStaticPaymentScheduleOptions = createSelector(
  offerStaticPaymentScheduleRequestInfo,
  getReserveForZeroPaymentScheduleRequestInfo,
  getCustomOfferV2ScheduleRequestInfo,
  (state: App.State) => isLpc50DepositExperimentVariantForces50Schedule(state),
  (state: App.State) => isLpc50DepositExperimentControlSuppressesSchedules(state),
  (offerInfo, reserveForZeroInfo, customOfferInfo, lpc50VariantForces50, lpc50ControlSuppresses): Array<StaticPaymentScheduleOption> => {
    if (lpc50ControlSuppresses) {
      return []
    }
    if (lpc50VariantForces50 && offerInfo?.templateId === STATIC_PAYMENT_SCHEDULE_TEMPLATE_ID) {
      return [{ id: offerInfo.templateId, requestInfo: offerInfo }]
    }
    const options: Array<StaticPaymentScheduleOption> = []
    const seen = new Set<string>()

    for (const info of [offerInfo, reserveForZeroInfo, customOfferInfo]) {
      if (info && !seen.has(info.templateId)) {
        seen.add(info.templateId)
        options.push({ id: info.templateId, requestInfo: info })
      }
    }

    return options
  },
)

export default getStaticPaymentScheduleOptions
